import React from 'react';

const cloneWithMaskClassName = (child: React.ReactNode) => {
  if (React.isValidElement(child)) {
    const baseClasses = child.props.className;

    return React.cloneElement(child, {
      className: baseClasses ? `${baseClasses} ctHidden` : 'ctHidden',
    } as React.HTMLAttributes<HTMLElement>);
  }

  return child;
};

interface IPiiMask {
  children: React.ReactNode;
}

export const PiiMask = ({ children }: IPiiMask) => {
  return React.Children.map(children, cloneWithMaskClassName) as unknown as JSX.Element;
};
